import { specialPromotionConstants } from '../constants'
import { specialPromotionService } from '../../services'
import { request, success, failure } from './helper'

function getPromotion(payload) {
  return async dispatch => {
    dispatch(request(specialPromotionConstants.GET_PROMOTION_REQUEST))
    try {
      const result = await specialPromotionService.loadSpecialPromotion(payload)
      if (result) {
        dispatch(success(specialPromotionConstants.GET_PROMOTION_SUCCESS, { result }))
      }
      return result
    } catch (error) {
      dispatch(failure(specialPromotionConstants.GET_PROMOTION_FAILURE, error))
      throw error
    }
  }
}

function redeemPromotion(payload) {
  return async dispatch => {
    dispatch(request(specialPromotionConstants.REDEEM_PROMOTION_REQUEST))
    try {
      const response = await specialPromotionService.redeemPromotion(payload)
      if (response) {
        return dispatch(
          success(specialPromotionConstants.REDEEM_PROMOTION_SUCCESS, {
            redemptionId: response.redemptionId,
          })
        )
      }
    } catch (error) {
      dispatch(failure(specialPromotionConstants.REDEEM_PROMOTION_ERROR, error))
    }
  }
}

function getTerms(payload) {
  return async dispatch => {
    dispatch(request(specialPromotionConstants.GET_PROMOTION_TERMS_REQUEST))
    try {
      const terms = await specialPromotionService.getTerms(payload)
      dispatch(success(specialPromotionConstants.GET_PROMOTION_TERMS_SUCCESS, { terms }))
    } catch (error) {
      dispatch(failure(specialPromotionConstants.GET_PROMOTION_TERMS_FAILURE, error))
      throw error
    }
  }
}

function getAllPromotions() {
  return async dispatch => {
    dispatch(request(specialPromotionConstants.GET_ALL_PROMOTIONS_REQUEST))
    try {
      const allPromotions = await specialPromotionService.getPromotions()
      dispatch(success(specialPromotionConstants.GET_ALL_PROMOTIONS_SUCCESS, { allPromotions }))
    } catch (error) {
      dispatch(failure(specialPromotionConstants.GET_ALL_PROMOTIONS_FAILURE, error))
      throw error
    }
  }
}

export default {
  getPromotion,
  redeemPromotion,
  getTerms,
  getAllPromotions,
}
